<div class="position-relative">
    <div *ngIf="createOrEditSalesRepInfo">
        <div class="container-fluid InfoForm thin-scroll">
            <div *ngFor="let salesRep of salesReps; let salesRepIndex = index">
                <div class="header p-3 my-2 d-flex align-items-center justify-content-between p-2">
                    <h6 *ngIf="salesRepIndex > 0"><span class="headertxt"> Sales Rep {{salesRepIndex}} : </span></h6>
                </div>

                <hr class="my-2" *ngIf="salesRepIndex > 0" />

                <div class="pr-3" *ngIf="salesRepIndex > 0">
                    <div class="row ml-1">
                        <app-contact class="w-100" [isCreateOrEdit]="createOrEditSalesRepInfo" [activeTab]="activeTab"
                            [currentTab]="currentTab"
                            [salesRepIndex]="salesRepIndex" [appTransactionsForViewDto]="appTransactionsForViewDto"
                            (updateAppTransactionsForViewDto)="onUpdateAppTransactionsForViewDto($event)"
                            (formValidityChanged)="isContactFormValid($event)"
                            [showDepartment]="activeTab == shoppingCartoccordionTabs.BuyerContactInfo">
                        </app-contact>
                    </div>
                </div>

                <hr class="my-2" *ngIf="salesRepIndex > 0" />
            </div>

            <div class="d-flex justify-content-end mt-3 pr-3">
                <button *ngIf="!showSaveBtn && salesReps?.length" [disabled]="!isContactsValid" (click)="createOrEditTransaction()"
                    class="continuebtn text-center btn">
                    Continue
                </button>
               
                <button *ngIf="showSaveBtn"        (click)="cancel" class="cancelbtn text-center btn ml-2">
                    Cancel
                    <!-- <i class="pi pi-times"></i> -->
                </button>
                <button *ngIf="showSaveBtn" (click)="save()" [disabled]="!isContactsValid"
                class="previewbtn text-center btn ml-2">
                Save
                <!-- <i class="pi pi-check"></i> -->
            </button>
            </div>
        </div>

        <br />
        <button class="addbtn mr-3" (click)="addNewSalesRep()" *ngIf="salesReps?.length <= 2">
            Add <i class="fa fa-plus" style="color:#F88011"></i>
        </button>
        <br /><br />
    </div>

    <div *ngIf="!createOrEditSalesRepInfo">
        <app-view-sales-rep-info [activeTab]="activeTab" [currentTab]="currentTab"
            [appTransactionsForViewDto]="appTransactionsForViewDto"
            (showSalesRepEditMode)="onShowSalesRepEditMode($event)" (onshowSaveBtn)="onshowSaveBtn($event)"
            [createOrEditSalesRepInfo]="createOrEditSalesRepInfo" [canChange]="canChange"
            (isContactsValid)="isContactFormValid($event)">
        </app-view-sales-rep-info>
    </div>
</div>


<!-- 
<p-dialog [(visible)]="visible " [modal]="true" [style]="{ width: '474px' }" [draggable]="false" >

    <div class=" con-body">
      <p class="mb-3">
        <svg class="mb-2" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.168 4.446C1.31469 4.22511 1.54311 4.07152 1.80302 4.01901C2.06294 3.9665 2.33306 4.01938 2.554 4.166L5.554 6.168C5.76621 6.31847 5.91143 6.54571 5.95884 6.80149C6.00625 7.05727 5.95213 7.32146 5.80795 7.53799C5.66377 7.75451 5.44089 7.90634 5.18661 7.96123C4.93233 8.01612 4.66666 7.96977 4.446 7.832L1.446 5.832C1.22543 5.685 1.07225 5.45643 1.02012 5.19654C0.967996 4.93665 1.02118 4.6667 1.168 4.446ZM16 4C13.6131 4 11.3239 4.94821 9.63604 6.63604C7.94821 8.32387 7 10.6131 7 13V17.802L5.072 22.628C5.01119 22.7797 4.98851 22.944 5.00593 23.1066C5.02335 23.2691 5.08034 23.4249 5.17192 23.5603C5.26349 23.6957 5.38686 23.8065 5.53123 23.8832C5.67559 23.9599 5.83654 24 6 24H26C26.1632 23.9998 26.3239 23.9597 26.468 23.8832C26.6122 23.8066 26.7354 23.6959 26.8269 23.5608C26.9184 23.4257 26.9755 23.2702 26.9931 23.108C27.0107 22.9457 26.9884 22.7816 26.928 22.63L25 17.8V13C25 10.6131 24.0518 8.32387 22.364 6.63604C20.6761 4.94821 18.3869 4 16 4ZM16 29C15.113 29.0002 14.2512 28.7056 13.5499 28.1626C12.8486 27.6195 12.3477 26.8588 12.126 26H19.874C19.6523 26.8588 19.1514 27.6195 18.4501 28.1626C17.7488 28.7056 16.887 29.0002 16 29ZM29.446 4.168C29.6667 4.03023 29.9323 3.98388 30.1866 4.03877C30.4409 4.09367 30.6638 4.24549 30.8079 4.46202C30.9521 4.67854 31.0063 4.94273 30.9588 5.19852C30.9114 5.4543 30.7662 5.68153 30.554 5.832L27.554 7.832C27.3333 7.96977 27.0677 8.01612 26.8134 7.96123C26.5591 7.90634 26.3362 7.75451 26.1921 7.53799C26.0479 7.32146 25.9937 7.05727 26.0412 6.80149C26.0886 6.54571 26.2338 6.31847 26.446 6.168L29.446 4.168ZM0 13C0 12.7348 0.105357 12.4804 0.292893 12.2929C0.48043 12.1054 0.734784 12 1 12H4C4.26522 12 4.51957 12.1054 4.70711 12.2929C4.89464 12.4804 5 12.7348 5 13C5 13.2652 4.89464 13.5196 4.70711 13.7071C4.51957 13.8946 4.26522 14 4 14H1C0.734784 14 0.48043 13.8946 0.292893 13.7071C0.105357 13.5196 0 13.2652 0 13ZM31 12C31.2652 12 31.5196 12.1054 31.7071 12.2929C31.8946 12.4804 32 12.7348 32 13C32 13.2652 31.8946 13.5196 31.7071 13.7071C31.5196 13.8946 31.2652 14 31 14H28C27.7348 14 27.4804 13.8946 27.2929 13.7071C27.1054 13.5196 27 13.2652 27 13C27 12.7348 27.1054 12.4804 27.2929 12.2929C27.4804 12.1054 27.7348 12 28 12H31Z" fill="#F6851D"/>
            </svg> 
            
            <span *ngIf="cancelBtn" class="msg-text ml-2">Your changes Discarded Successfuly </span>
            <span *ngIf="saveBtn" class="msg-text ml-2">Are you sure you want to save changes you made ?</span>
    </p>

    </div>
  
  
    <div *ngIf="cancelBtn" class="d-flex justify-content-center btns" >
    
      <button  (click)="visible = false;cancel()" label="Ok" Class="p-button-text">Ok</button>
      <button  (click)="visible = false;SuccessMsg = true ;cancel()" label="Yes" class="p-button-text" >Yes</button>
    </div>

    <div *ngIf="saveBtn" class="d-flex justify-content-center btns" >
    
        <button  (click)="visible = false ;"  label="No" Class="p-button-no">No</button>
        <button  (click)="save();visible = false" label="Yes" class="p-button-text" >Yes</button>
      </div>
  </p-dialog>


  <p-dialog [(visible)]="SuccessMsg" [modal]="true" [style]="{ width: '474px' }" [draggable]="false" >
<div class="d-flex justify-content-center img-hd m-auto">
    <img src="../../../../../assets/icons/success-Purble.svg">

</div>
    <div class=" con-body">

      <p class="mb-3 text-center">
            
            <span *ngIf="cancelBtn" class="msg-text ml-2 ">Changes discarded successfuly</span>
            <span *ngIf="saveBtn" class="msg-text ml-2 ">Changes saved successfuly</span>
    </p>

    </div>
  
  
    <div class="d-flex justify-content-center btns" >
    
 
      <button  (click)="SuccessMsg = false" label="Ok" class="p-button-text" >Ok</button>
    </div>
  </p-dialog> -->